<template>

    <a-modal class="invitation"
             centered
             :width="900"
             :visible="visible"
             @cancel="$emit('cancel')"
             :maskClosable="false"
             :footer="null"
             :destroyOnClose="true"
             :confirmLoading="modalLoading">
        <a-card>
            <div class="t1">
                <div class="size4 mb-5 bold" style="color: #EA0000">{{inviteInfo.supplierName}}:</div>
                <div class="size3 t1-a">
                    <p class="">
                        <b>{{inviteInfo.extras.dljgmc}}</b>受<b>{{inviteInfo.extras.wtrdwmc}}</b>委托，组织<b>{{inviteInfo.extras.xmmc}}({{inviteInfo.extras.xmbh}})</b>需求调查，现邀请贵公司参与本次调查活动。
                    </p>
                    <p v-if="inviteInfo.extras.zjfs && inviteInfo.extras.zjfs==='2'">请点击<u class="color-link" @click="DemandSignIndex">报名链接</u>，前往报名。</p>
                    <p>如同意参与项目调查，请点击报名链接中进行报名。如不同意参与，则不需做任何操作。</p>
                    <p>如有疑问，请联系我司项目经办人<B>{{inviteInfo.extras.xmzbrText}}（{{inviteInfo.extras.dljgdh}}）</B>。感谢贵单位对本次调查活动工作的支持！</p>
                </div>
            </div>
            <p class="t2">{{inviteInfo.extras.dljgmc}}</p>
        </a-card>
    </a-modal>

</template>

<script>
    import qs from 'qs'
    export default {
        name: 'InviteDemandDetails',
        components: {
        },
        created() {
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                modalLoading: false,
                inviteInfo: {extras:{}}
            }
        },
        methods: {
            initData(id) {
                let that = this
                this.$http.get('/api/v1/supplier/project/getDemandInvitedDetails.json?id='+id).then(function (res) {
                    that.inviteInfo =  res.result
                });
            },
            DemandSignIndex() {
                this.$router.push({path: '/DemandSignIndex?id=' + this.inviteInfo.projectId})
            },
        }
    };
</script>
<style lang="less" scoped>
    /deep/ .ant-modal-content{
        background: none;
        box-shadow: none;
    }
    /deep/ .ant-card{
        background: url("../../img/p4.png");
        background-size: 100%;
        border: none;
        height: 557px;
    }
    /deep/ .ant-modal-close-x{
        border: 2px solid #fff;
        color: #fff;
        width: 36px;
        height: 36px;
        line-height: 32px;
        border-radius: 18px;
        font-weight: bold;
    }
    /deep/ .ant-modal-close {
        top: -20px;
        right: 20px;
    }
    .t1{
        padding: 100px 40px 40px;
        color: #333;
    }
    .t1-a p{
        text-indent: 32px;
        padding: 0 10px 0 30px;
    }
    .t1-a u{
        cursor: pointer;
    }
    .t2{
        position: absolute;bottom: 20px;width: 100%;text-align: center;color: #FEE7B4;left: 0
    }
</style>
